import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import css from './ScoreDefinitionsView.scss';
import commonCss from './Common.scss';
import ScoreDefinitionView from './ScoreDefinitionView';
import { withLoader } from '../../common/withLoader';

class ScoreDefinitionsView extends React.Component {

  getScoresView(scores, scoresClassName) {
    return scores.map(scoreDefinition => {
              return <ScoreDefinitionView className={scoresClassName}
                                      key={scoreDefinition.scoreDefinitionId}
                                      scoreDefinition={scoreDefinition} />;
            });
  }

  render() {
    return (
      <div className={css['container']}>
        <h3 className="sf-student-folder-subtitle sf-dotted-line-bottom">Significant Retention Score Factors</h3>
        <Table celled compact size="small" striped className={css['score-factors']}>
          <Table.Header className={css['table-header']}>
            <Table.Row>
              <Table.HeaderCell width="one" className={commonCss['centered']}>Impact</Table.HeaderCell>
              <Table.HeaderCell width="five" className={commonCss['centered']}>Score Factor</Table.HeaderCell>
              <Table.HeaderCell width="one" className={commonCss['centered']}>Value</Table.HeaderCell>
              <Table.HeaderCell width="nine" className={commonCss['centered']}>Intervention Inventory</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body className={css['score-definitions']}>
            {this.getScoresView(this.props.negativeScoreDefinitions, 'negative-scores-list')}
            {this.getScoresView(this.props.positiveScoreDefinitions, 'positive-scores-list')}
          </Table.Body>
        </Table>
      </div>
    );
  }
}

ScoreDefinitionsView.propTypes = {
  positiveScoreDefinitions: PropTypes.array.isRequired,
  negativeScoreDefinitions: PropTypes.array.isRequired
};

export default withLoader(ScoreDefinitionsView);
